import { useFlag } from 'shared/settings/FeatureToggles';
import { useSuggestedLoads } from '../../data/LoadboardPostingAPI';
import { SuggestedLoadsSlider } from '../posting-list/SuggestedLoadsSlider';

export function HomeScreenSuggestedLoadsSlider() {
  const isSliderInAvailableEnabled = useFlag(
    'slb_suggested_slider_in_available',
  );
  const { data: suggestedLoads } = useSuggestedLoads(
    { size: 5 },
    { enabled: !isSliderInAvailableEnabled },
  );

  if (isSliderInAvailableEnabled || !suggestedLoads?.data?.length) {
    return null;
  }

  return (
    <SuggestedLoadsSlider
      suggestedLoads={suggestedLoads.data}
      headingSize="heading-3"
      utmMedium="Home Screen Slider"
    />
  );
}
